var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiBankLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78802 20.3398H22.7533V22.3364H2.78802V20.3398ZM4.78455 12.3537H6.78108V19.3416H4.78455V12.3537ZM9.77587 12.3537H11.7724V19.3416H9.77587V12.3537ZM13.7689 12.3537H15.7655V19.3416H13.7689V12.3537ZM18.7602 12.3537H20.7568V19.3416H18.7602V12.3537ZM2.78802 7.36241L12.7707 2.37109L22.7533 7.36241V11.3555H2.78802V7.36241ZM4.78455 8.59627V9.35894H20.7568V8.59627L12.7707 4.60321L4.78455 8.59627ZM12.7707 8.36068C12.5059 8.36068 12.252 8.2555 12.0648 8.06829C11.8776 7.88108 11.7724 7.62717 11.7724 7.36241C11.7724 7.09766 11.8776 6.84374 12.0648 6.65653C12.252 6.46932 12.5059 6.36415 12.7707 6.36415C13.0354 6.36415 13.2893 6.46932 13.4765 6.65653C13.6638 6.84374 13.7689 7.09766 13.7689 7.36241C13.7689 7.62717 13.6638 7.88108 13.4765 8.06829C13.2893 8.2555 13.0354 8.36068 12.7707 8.36068Z",
    fill: "#383E42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiBankLine);
export default __webpack_public_path__ + "static/media/ri_bank-line.59c5aa26fd0ed5065f1d9cf200ec8528.svg";
export { ForwardRef as ReactComponent };